import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-control-efectivo-cliente',
  templateUrl: './control-efectivo-cliente.component.html',
  styleUrls: ['./control-efectivo-cliente.component.scss']
})
export class ControlEfectivoClienteComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
